import React from 'react';
import {Table, Paper} from 'material-ui';
import TableRolesHeader from './TableRolesHeader';
import TableGroupedPermissions from './TableGroupedPermissions';

const TableRolesPermissionsGroups = ({permissions, permissionsGroups, roles, rolesPermissions, changeRolePermission, classes}) => (
    <Paper className={classes.root}>
        <Table className={classes.table}>
            <TableRolesHeader
                roles={roles}
                classes={classes}
            />
            {permissionsGroups.map(group => {
                const groupPerms = group.permissions;
                return (
                    <TableGroupedPermissions
                        key={'groupid-' + group.id}
                        classes={classes}
                        group={group}
                        groupPerms={groupPerms}
                        rolesPermissions={rolesPermissions}
                        roles={roles}
                        changeRolePermission={changeRolePermission}
                    />
                )
            })}
        </Table>
    </Paper>
)

export default TableRolesPermissionsGroups;


// WEBPACK FOOTER //
// ./src/containers/roles/forms/TableRolesPermissionsGroups.jsx